import React from 'react';
import {FormattedDateTime, FormattedDateTimeProps} from '../FormattedDateTime/FormattedDateTime';

interface Props extends Omit<FormattedDateTimeProps, 'date' | 'style'> {
  start?: Date | number;
  end?: Date | number | undefined;
  style?: React.CSSProperties;
}

export const FormattedDateTimeRange = (props: Props) => {
  const {start, end, style, ...rest} = props

  if (!start) {
    return null
  }

  return (
    <span style={props.style}>
      <FormattedDateTime
        {...rest}
        date={props.start}
      />
      {' - '}
      {props.end ? (
        <FormattedDateTime
          {...rest}
          date={props.end}
        />
      ) : (
        '...'
      )}
    </span>
  );
};
